import axios from "axios";
//require('dotenv').config()

// import store from 'common/redux/store';
// import { logout } from 'common/redux/user/actions';
// import Auth from "services/Auth";

//import AppConfig from "../../config";

//import config from 'config';

import {
  suscribe,
  getOptions,
  getAttributes,
  getFilterProductsElastic,
  getCartLocal,
  setCartLocal,
  getLayoutTemplateByName,
} from "./functions";

const api = axios.create({
  //baseURL: 'http://localhost:8080'
  baseURL: process.env.REACT_APP_APIBACK_CONFIG,
  //baseURL: 'https://back.casaideas.com.bo'
  // timeout: 1000,
});
//const parse_res = (api) => api.then((data) => data.data);

const parse_res = (promise) =>
  promise
    .then((res) => res.data)
    .catch((err) => {
      if (err.response && err.response.data) {
        return err.response.data; // devuelve el cuerpo del error 400
      }
      throw err; // relanza si es un error de red u otro
    });


const ApiV2 = {
  init: {
    init: () => console.log("init"),
  },
  menu: {
    userMenu: () => parse_res(api.get(`/api/getMenu`)),
    adminMenu: () => parse_res(api.get(`/api/getuserMenu`)),
  },
  customApi: (data) =>
    parse_res(
      api.post(
        `/externalapi/execute/` +
        data.apiName +
        `/key/3452356rtshfghsdfgy456fh`,
        data
      )
    ),

  customer: {
    /*miscellaneous*/


    getActiveCombos: (data) => {
      if (typeof data === "object" && data) {
        const url = `${process.env.REACT_APP_APIDISC_CONFIG}/api/frontend/getActiveCombos`;
        return parse_res(api.post(url, data));
      }
    },


    getFilterProducts: (data) => getFilterProductsElastic(data),
    getFilterProductsNew: (data) => getFilterProductsElastic(data),

    getFilterProductsDB: (data) =>
      parse_res(api.post(`/customerapi/getFilterProducts`, data)),

    getHeaderMenu: (data) =>
      parse_res(api.post(`/customerapi/getHeaderMenu`, data)),

    getProductById: (data) => {
      if (typeof data === "object" && data.productid) {
        const url = `${process.env.REACT_APP_APIPROD_CONFIG}?id=${data.productid}`;
        return parse_res(api.get(url));
      }
      const url = `${process.env.REACT_APP_APIPROD_CONFIG}?id=${data}`;
      return parse_res(api.get(url));
    },


    getProductByIds: (data) => {
      const url = `${process.env.REACT_APP_APIPROD_CONFIG}`;
      //return parse_res(api.post(url, data));
      if (typeof data === "object" && data) {
        //const url = `${process.env.REACT_APP_APIEVEN_CONFIG}/api/event/getById?id=${data.id}`;
        const headers = {};
        // Solo agrega el header si existe accesskey
        if (data.accessKey) {
          headers.Authorization = `Bearer ${data.accessKey}`;
        }
        return parse_res(api.post(url, data, { headers }));
      }

    },


    getProductByIdElastic: (data) => getFilterProductsElastic(data),

    //getOptions                  : (data) => parse_res(api.post(`/customerapi/getOptions`,  data )),
    /*
    getOptionsDB: (data) =>
      parse_res(api.post(`/customerapi/getOptions`, data)),
    */

    setEvent: (data) => {
      if (typeof data === "object" && data) {
        const url = `${process.env.REACT_APP_APIEVEN_CONFIG}/api/event/insert`;
        return parse_res(api.post(url, data));
      }
    },
    updEvent: (data) => {
      if (typeof data === "object" && data) {
        const url = `${process.env.REACT_APP_APIEVEN_CONFIG}/api/event/update`;
        return parse_res(api.post(url, data));
      }
    },

    getOptionsDB: (data) => {
      if (typeof data === "object" && data) {
        const url = `${process.env.REACT_APP_APIINT_CONFIG}/api/frontend/getDomain`;
        return parse_res(api.post(url, data));
      }
    },

    getMessagesDB: (data) => {
      if (typeof data === "object" && data) {
        const url = `${process.env.REACT_APP_APIINT_CONFIG}/api/frontend/getDomain`;
        return parse_res(api.post(url, data));
      }
    },


    getTagsDB: (data) => {
      if (typeof data === "object" && data) {
        const url = `${process.env.REACT_APP_APIINT_CONFIG}/api/frontend/getDomain`;
        return parse_res(api.post(url, data));
      }
    },
    getAttributesDB: (data) => {
      if (typeof data === "object" && data) {
        const url = `${process.env.REACT_APP_APIINT_CONFIG}/api/frontend/getDomain`;
        return parse_res(api.post(url, data));
      }
    },
    getOptions: (data) => getOptions(data),
    getFilterProductsElastic: (data) =>
      parse_res(api.post(`/customerapi/getFilterProductsElastic`, data)),

    prevalOrderDiscount: (data) => {
      if (typeof data === "object" && data) {
        const url = `${process.env.REACT_APP_APIDISC_CONFIG}/api/frontend/coupon/prevalOrderDiscount`;
        //const url = `http://localhost:3000/dev/discounts/api/frontend/coupon/prevalOrderDiscount`;
        return parse_res(api.post(url, data));
      }
    },
    /*
        checkCartProducts: (data) =>
          parse_res(api.post(`/customerapi/checkCartProducts`, data)),
    */
    checkCartProducts: (data) => {
      if (typeof data === "object" && data) {
        const url = `${process.env.REACT_APP_APIORDR_CONFIG}/api/order/checkCartProducts`;

        return parse_res(api.post(url, data));
      }
    },

    prevalCoupon: (data) =>
      parse_res(api.post(`${process.env.REACT_APP_APIDISC_CONFIG}/api/frontend/coupon/prevalCoupon`, data)),
    unlockCoupon: (data) =>
      parse_res(api.delete(`${process.env.REACT_APP_APIDISC_CONFIG}/api/frontend/coupon/unlockCoupon`, { data })),
    getValCouponByUser: (data) =>
      parse_res(api.post(`${process.env.REACT_APP_APIDISC_CONFIG}/api/frontend/coupon/getValCouponByUser`, data)),
    getAttributes: (data) => getAttributes(data),


    getCategories: (data) =>
      parse_res(api.post(`/customerapi/getCategories`, data)),
    getCategoriesByStore: (data) =>
      parse_res(api.post(`/customerapi/getCategoriesByStore`, data)),
    getProductQuantity: (data) =>
      parse_res(api.post(`/customerapi/getProductQuantity`, data)),
  },

  manager: {
    /*
   
    */
  },
  /*layaoutManager*/
  layaoutManager: {
    getLayoutTemplateByNameOld: (data) =>
      parse_res(api.post(`/api/layout/getLayoutTemplateByName`, data)),
    getLayoutTemplateByName: (data) =>
      parse_res(api.post(`/api/s3/getFile`, data)),
    getProducts: (data) => parse_res(api.post(`/api/layout/getProducts`, data)),

    getLayoutTemplateByNameNew: (data) => getLayoutTemplateByName(data),
  },

  /*frontend*/
  frontend: {
    getPaymentTypesByStoreId: (data) => {
      if (typeof data === "object" && data) {
        const url = `${process.env.REACT_APP_APIINT_CONFIG}/api/frontend/getDomain`;
        return parse_res(api.post(url, data));
      }
    },
    getCustomDomain: (data) => {
      if (typeof data === "object" && data) {
        const url = `${process.env.REACT_APP_APIINT_CONFIG}/api/frontend/getDomain`;
        return parse_res(api.post(url, data));
      }
    },
    getCustomerEventsByUserId: (data) => {
      if (typeof data === "object" && data.id) {
        const url = `${process.env.REACT_APP_APIEVEN_CONFIG}/api/event/getByCustomerId?id=${data.id}`;
        return parse_res(api.get(url));
      }
      const url = `${process.env.REACT_APP_APIEVEN_CONFIG}/api/event/getByCustomerId?id=${data}`;
      return parse_res(api.get(url));
    },

    getCustomerById: (data) => {
      if (typeof data === "object" && data.customerid) {
        const url = `${process.env.REACT_APP_APIBACK_CONFIG}/api/frontend/customers/${data.customerid}`;
        return parse_res(api.get(url));
      }
      const url = `${process.env.REACT_APP_APIBACK_CONFIG}/api/frontend/customers/${data}`;
      return parse_res(api.get(url));
    },

    changePassword: (data) => {
      if (typeof data === "object" && data) {
        const url = `${process.env.REACT_APP_APIBACK_CONFIG}/api/frontend/changePassword`;
        return parse_res(api.post(url, data));
      }
    },

    getCustomerEventById: (data) => {

      if (typeof data === "object" && data.id) {
        const url = `${process.env.REACT_APP_APIEVEN_CONFIG}/api/event/getById?id=${data.id}`;
        const headers = {};
        // Solo agrega el header si existe accesskey
        if (data.accessKey) {
          headers.Authorization = `Bearer ${data.accessKey}`;
        }
        return parse_res(api.get(url, { headers }));
      }
      const url = `${process.env.REACT_APP_APIEVEN_CONFIG}/api/event/getById?id=${data}`;
      return parse_res(api.get(url));
    },

    getPublicCustomerEventById: (data) => {
      if (typeof data === "object" && data.id) {
        const url = `${process.env.REACT_APP_APIEVEN_CONFIG}/api/frontend/event/getById?id=${data.id}`;
        const headers = {};
        // Solo agrega el header si existe accesskey
        return parse_res(api.get(url, { headers }));
      }
      const url = `${process.env.REACT_APP_APIEVEN_CONFIG}/api/frontend/event/getById?id=${data}`;
      return parse_res(api.get(url));
    },


    getPublicCustomerEventByToken: (data) => {
      if (typeof data === "object" && data.token) {
        const url = `${process.env.REACT_APP_APIEVEN_CONFIG}/api/frontend/event/getByToken?token=${data.token}`;
        return parse_res(api.get(url));
      }
    },

    getCustomerEventByToken: (data) => {

      if (typeof data === "object" && data.token) {
        const url = `${process.env.REACT_APP_APIEVEN_CONFIG}/api/event/getByToken?token=${data.token}`;
        const headers = {};
        // Solo agrega el header si existe accesskey
        if (data.accessKey) {
          headers.Authorization = `Bearer ${data.accessKey}`;
        }
        return parse_res(api.get(url, { headers }));
      }
    },



    setProductEvent: (data) => {
      if (typeof data === "object" && data) {
        const url = `${process.env.REACT_APP_APIEVEN_CONFIG}/api/event/update/addproduct`;
        return parse_res(api.patch(url, data));
      }
    },
    updateProductEvent: (data) => {
      if (typeof data === "object" && data) {
        const url = `${process.env.REACT_APP_APIEVEN_CONFIG}/api/event/update/addproduct`;
        return parse_res(api.patch(url, data));
      }
    },
    deleteProductEvent: (data) => {
      if (typeof data === "object" && data) {
        const url = `${process.env.REACT_APP_APIEVEN_CONFIG}/api/event/delete/delproduct`;
        return parse_res(api.delete(url, { data }));
      }
    },


    //getCart: (data) => parse_res(api.post(`/api/frontend/getCart`, data)),
    getCart: (data) => getCartLocal(data),
    //setCart: (data) => parse_res(api.put(`/api/frontend/setCart`, data)),
    setCart: (data) => setCartLocal(data),



    setCustomers: (data) => {
      if (typeof data === "object" && data) {
        const url = `${process.env.REACT_APP_APIBACK_CONFIG}/api/frontend/customers`;
        return parse_res(api.post(url, data));
      }
    },

    updateCustomers: (data) => {
      if (typeof data === "object" && data) {
        const url = `${process.env.REACT_APP_APIBACK_CONFIG}/api/frontend/customers`;
        return parse_res(api.put(url, data));
      }
    },

    updateBirthDay: (data) => {
      if (typeof data === "object" && data) {
        const url = `${process.env.REACT_APP_APIBACK_CONFIG}/api/frontend/customers/birthday`;
        return parse_res(api.put(url, data));
      }
    },

    changePasswordByToken: (data) => {
      if (typeof data === "object" && data) {
        const url = `${process.env.REACT_APP_APIBACK_CONFIG}/api/frontend/changePasswordByToken`;
        return parse_res(api.post(url, data));
      }
    },
    getStores: (data) => parse_res(api.post(`/api/frontend/getStores`, data)),
    setCustomerAddress: (data) => {
      if (typeof data === "object" && data) {
        const url = `${process.env.REACT_APP_APIBACK_CONFIG}/api/frontend/customers/add/address`;
        return parse_res(api.put(url, data));
      }
    },

    checkCoords: (data) => {
      if (typeof data === "object" && data) {
        const url = `${process.env.REACT_APP_APIINT_CONFIG}/api/frontend/checkCoords`;
        return parse_res(api.post(url, data));
      }
    },


    updateCustomerAddress: (data) =>
      parse_res(api.put(`/api/frontend/updateCustomerAddress`, data)),
    deleteCustomerAddress: (data) =>
      parse_res(api.put(`/api/frontend/deleteCustomerAddress`, data)),


    login: (data) => {
      if (typeof data === "object" && data) {
        const url = `${process.env.REACT_APP_APIBACK_CONFIG}/api/frontend/login`;
        return parse_res(api.post(url, data));
      }
    },
    loginSNKey: (data) => {
      if (typeof data === "object" && data) {
        const url = `${process.env.REACT_APP_APIBACK_CONFIG}/api/frontend/loginSN`;
        return parse_res(api.post(url, data));
      }
    },
    getTokenEmail: (data) => {
      if (typeof data === "object" && data) {
        const url = `${process.env.REACT_APP_APIBACK_CONFIG}/api/frontend/getTokenEmail`;
        return parse_res(api.post(url, data));
      }
    },

    recoveryPass: (data) => {
      if (typeof data === "object" && data) {
        const url = `${process.env.REACT_APP_APIBACK_CONFIG}/api/frontend/recoveryPass`;
        return parse_res(api.post(url, data));
      }
    },

    getOrders: (data) => parse_res(api.post(`/api/frontend/getOrders`, data)),

    getStatusOrders: (data) => {
      if (typeof data === "object" && data) {
        const url = `${process.env.REACT_APP_APIINT_CONFIG}/api/frontend/getDomain`;
        return parse_res(api.post(url, data));
      }
    },

    getOrderById: (data) => {
      if (typeof data === "object" && data) {
        const url = `${process.env.REACT_APP_APIORDR_CONFIG}/api/frontend/getOrderDetails`;
        return parse_res(api.post(url, data));
      }
    },

    checkOrderPaid: (data) => {
      if (typeof data === "object" && data) {
        const url = `${process.env.REACT_APP_APIORDR_CONFIG}/api/order/checkOrderPaid`;
        return parse_res(api.post(url, data));
      }
    },

    setOrderNotify: (data) =>
      parse_res(api.put(`/api/frontend/setOrderNotify`, data)),

    getOrderByCustomerId: (data, headers) => {
      if (typeof data === "object" && data) {
        const url = `${process.env.REACT_APP_APIORDR_CONFIG}/api/frontend/getOrderByCustomerId`;
        return parse_res(
          api.get(url, {
            params: data,
            headers: headers ?? {}
          })
        );
      }
    },

    setOrders: (data) => {
      if (typeof data === "object" && data) {
        const url = `${process.env.REACT_APP_APIORDR_CONFIG}`;
        return parse_res(api.put(url, data));
      }
    },

    setOrdersCoupons: (data) => {
      if (typeof data === "object" && data) {
        const url = `${process.env.REACT_APP_APIORDR_CONFIG}`;
        return parse_res(api.put(url, data));
      }
    },

    getFormShippingTypes: (data) => {
      if (typeof data === "object" && data) {
        const url = `${process.env.REACT_APP_APIINT_CONFIG}/api/frontend/getFormShippingTypes`;
        return parse_res(api.post(url, data));
      }
    },

    setExternalOrders: (data) =>
      parse_res(api.put(`/api/frontend/setExternalOrders`, data)),

    updateStatusPending: (data) => {
      if (typeof data === "object" && data) {
        const url = `${process.env.REACT_APP_APIORDR_CONFIG}`;
        return parse_res(api.put(url, data));
      }
    },

    updateOrders: (data) =>
      parse_res(api.put(`/api/frontend/updateOrders`, data)),

    addWishlist: (data) => {
      if (typeof data === "object" && data) {
        const url = `${process.env.REACT_APP_APIBACK_CONFIG}/api/frontend/wishlist/create`;
        return parse_res(api.put(url, data));
      }
    },

    delWishlist: (data) => {
      if (typeof data === "object" && data) {
        const url = `${process.env.REACT_APP_APIBACK_CONFIG}/api/frontend/wishlist/delete`;
        return parse_res(api.delete(url, { data }));
      }
    },

    getWishListDB: (data, headers) => {
      if (typeof data === "object" && data) {
        const url = `${process.env.REACT_APP_APIBACK_CONFIG}/api/frontend/wishlist/get`;
        return parse_res(
          api.get(url, {
            params: data,
            headers: headers ?? {}
          })
        );
      }
    },
    getTokenWishlist: (data) =>
      parse_res(api.post(`/api/frontend/getTokenWishlist`, data)),
    getTokenEventlist: (data) =>
      parse_res(api.post(`/api/frontend/getTokenEventlist`, data)),
    decodeToken: (data) =>
      parse_res(api.post(`/api/frontend/decodeToken`, data)),
    decodePrivateToken: (data) =>
      parse_res(api.post(`/api/frontend/decodePrivateToken`, data)),
    getPaymentTypes: (data) =>
      parse_res(api.post(`/api/frontend/getPaymentTypes`, data)),

    getShippingTypes: (data) => {
      if (typeof data === "object" && data) {
        const url = `${process.env.REACT_APP_APIINT_CONFIG}/api/frontend/getDomain`;
        return parse_res(api.post(url, data));
      }
    },

    getEventTypes: (data) => {
      if (typeof data === "object" && data) {
        const url = `${process.env.REACT_APP_APIINT_CONFIG}/api/frontend/getDomain`;
        return parse_res(api.post(url, data));
      }
    },



    searchEvents: (data) =>
      parse_res(api.post(`/api/frontend/searchEvents`, data)),


    getTokenManageEvent: (data) =>
      parse_res(api.post(`/api/frontend/getTokenManageEvent`, data)),
    getPolygonsByCity: (data) =>
      parse_res(api.post(`/api/frontend/getPolygonsByCity`, data)),

    /*cart*/
    updateCart: (data) => parse_res(api.put(`/api/frontend/updateCart`, data)),
    deleteCartByUserId: (data) =>
      parse_res(api.put(`/api/frontend/deleteCartByUserId`, data)),
    deleteCart: (data) => parse_res(api.put(`/api/frontend/deleteCart`, data)),

    getUserInfoByCartID: (data) =>
      parse_res(api.post(`/api/frontend/getUserInfoByCartID`, data)),


    getAcviteCartsByUserId: (data) =>
      parse_res(api.post(`/api/frontend/getAcviteCartsByUserId`, data)),

    shopStatus: () => { return { status: true, success: true } }

  },



  /*s3*/
  s3: {
    listFiles: (data) => parse_res(api.post(`/api/s3/listFiles`, data)),
    uploadImage: (data) =>
      parse_res(
        api.post(
          `${process.env.REACT_APP_APIS3B_CONFIG}/api/S3/customer/uploadImage`,
          data
        )
      ),
  },

  /*predefined apis for forms*/
  predefined: {
    suscribe: (data) => suscribe(data),
  },
};

export default ApiV2;

export const setApiTokenV2 = async (token) => {
  //console.log("set token", token)
  api.defaults.headers.common["Authorization"] = "Bearer " + token;
};
